<template>
    <AppModal :name="name" :beforeOpen="beforeOpen">
        <template slot="header">
            <span class="text-purple font-90"><i class="fal fa-plug"></i></span>
            <h1 class="mb-4 mt-5">
                {{ isConfigure ? 'Please configure a sending address' : 'Setup your inbox' }}
            </h1>
        </template>
        <template slot="content">
            <h6>
                In order to send and receive emails from {{ appDisplayName }}, <br>
                connect and verify your existing email account
            </h6>
            <p>Lets set-up your integration.</p>
        </template>
        <template slot="actions">
            <button @click="getSetup" class="btn btn-primary">
                Get Setup
            </button>
            <br>
            <button @click="skip" class="btn btn-link mt-3">
                I'll do this later
            </button>
        </template>
    </AppModal>
</template>

<script>

import {mapGetters} from 'vuex'
import {SETTINGS_INBOXES} from '../../views/settings/settings-tabs'

export default {
    name: 'NoInbox',
    props: {
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            onSkipSetup: null,
            isConfigure: false
        }
    },
    computed: {
        ...mapGetters(['activeTeam'])
    },
    methods: {
        beforeOpen({params}) {
            if (params) {
                if (params.onSkipSetup) {
                    this.onSkipSetup = params.onSkipSetup
                }

                if (params.isConfigure) {
                    this.isConfigure = params.isConfigure
                }
            }
        },

        skip() {
            this.$modal.hide(this.name)
            if (typeof this.onSkipSetup === 'function') {
                this.onSkipSetup()
            }
        },

        getSetup() {
            this.$modal.hide(this.name)
            this.$router.push({name: 'settings', params: {page: SETTINGS_INBOXES}})
        }
    }
}
</script>
